import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'memorandum',
        name: 'memorandum',
        component: () => import('@/views/Memorandum'),
        meta: {
          breadcrumb: [{
            name: '認證考試',
          },
          {
            name: '合作備忘錄申請',
            link: 'memorandum'
          }]
        }
      },
      {
        path: 'projectApplication',
        name: 'projectApplication',
        component: () => import('@/views/ProjectApplication'),
        meta: {
          breadcrumb: [{
            name: '認證考試',
          },
          {
            name: '專案認證申請',
            link: 'projectApplication'
          }]
        }
      },
      {
        path: 'registrationList',
        name: 'registrationList',
        component: () => import('@/views/RegistrationList'),
        meta: {
          breadcrumb: [{
            name: '認證考試',
          },
          {
            name: '專案認證考試報名',
            link: 'registrationList'
          }]
        }
      },
      {
        path: 'registration/:id?',
        name: 'registration',
        component: () => import('@/views/Registration'),
        meta: {
          breadcrumb: [{
            name: '認證考試',
          },
          {
            name: '專案認證考試報名',
            link: 'registrationList'
          },
          {
            name: '報名資料填寫'
          }]
        }
      },
      {
        path: 'projectList',
        name: 'projectList',
        component: () => import('@/views/ProjectList'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '已申請專案認證查詢',
            link: 'projectList'
          }]
        }
      },
      {
        path: 'project/:id?',
        name: 'project',
        component: () => import('@/views/Project'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '已申請專案認證查詢',
            link: 'projectList'
          },
          {
            name: '場次資訊'
          }]
        }
      },
      {
        path: 'projectMemberInfo/:id?',
        name: 'projectMemberInfo',
        component: () => import('@/views/ProjectMemberInfo'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '已申請專案認證查詢',
            link: 'projectList'
          },
          {
            name: '場次資訊',
            link: 'project/:id?'
          },
          {
            name: '考生資訊'
          }]
        }
      },
      {
        path: 'applyCertificate/:id?',
        name: 'applyCertificate',
        component: () => import('@/views/ApplyCertificate'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '已申請專案認證查詢',
            link: 'projectList'
          },
          {
            name: '場次資訊',
            link: 'project/:id?'
          },
          {
            name: '申請紙本證書'
          }]
        }
      },
      {
        path: 'applyCertificatePersonal/:id?',
        name: 'applyCertificatePersonal',
        component: () => import('@/views/ApplyCertificatePersonal'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '報名資訊查詢',
            link: 'registerInformationList'
          },
          {
            name: '報名資訊',
            link: 'registerInformation/:id?'
          },
          {
            name: '申請紙本證書'
          }]
        }
      },
      {
        path: 'registerInformationList',
        name: 'registerInformationList',
        component: () => import('@/views/RegisterInformationList'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '報名資訊查詢',
            link: 'registerInformationList'
          }]
        }
      },
      {
        path: 'registerInformation/:id?',
        name: 'registerInformation',
        component: () => import('@/views/RegisterInformation'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '報名資訊查詢',
            link: 'registerInformationList'
          },
          {
            name: '報名資訊'
          }]
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/Profile'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '帳號資料修改',
            link: 'profile'
          }]
        }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/Contact'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '聯絡我們',
            link: 'contact'
          }]
        }
      },
      {
        path: 'myCertificateList',
        name: 'myCertificateList',
        component: () => import('@/views/MyCertificateList'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '我的證照庫',
            link: 'myCertificateList'
          }]
        }
      },
      {
        path: 'projectManagementList',
        name: 'projectManagementList',
        component: () => import('@/views/ProjectManagementList'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '證書管理專用',
            link: 'projectManagementList'
          }]
        }
      },
      {
        path: 'projectManagement/:id?',
        name: 'projectManagement',
        component: () => import('@/views/ProjectManagement'),
        meta: {
          breadcrumb: [{
            name: '使用者專區',
          },
          {
            name: '證書管理專用',
            link: 'projectManagementList'
          },
          {
            name: '場次資訊'
          }]
        }
      },
    ]
  },

  {
    path: '/login',
    component: () => import('@/views/Login'),
  },
  {
    path: '/forgetPassword',
    component: () => import('@/views/ForgetPassword'),
  },
  {
    path: '/loginRegister',
    component: () => import('@/views/LoginRegister'),
  },
  {
    path: '/certificateVerification',
    component: () => import('@/views/CertificateVerification'),
  },
  {
    path: '/fastRegistration',
    component: () => import('@/views/FastRegistration'),
  },
  {
    path: '/download',
    component: () => import('@/views/Download'),
  },
  {
    path: '/downloadLink',
    component: () => import('@/views/DownloadLink'),
  },
  {
    path: '/link',
    component: () => import('@/views/Link'),
  },
  {path: '*', redirect: '/' }

  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     // meta: { title: 'Dashboard', icon: 'dashboard' }
  //   }]
  // },
]

const router = new VueRouter({
  routes
})

export default router
